'use es6';

import { FetchTBPilotStatusRequestTypes } from '../actions/TBPilotStatusActions';
const initialState = false;

const TBPilotStatus = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchTBPilotStatusRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default TBPilotStatus;